import {
    PROMOS_HYDRATED,
    SET_PROMO_URL_CODE,
    SET_PROMO_ENTERED_CODE,
    CLEAR_PROMO_ENTERED_CODE,
} from '../actions/actionTypes';
import initialState from './initialState';

export default function promosReducer(state = initialState.promos, action) {
    switch (action.type) {
        case PROMOS_HYDRATED:
            return { ...state, list: action.promos || [], hydrated: true };
        case SET_PROMO_URL_CODE:
            return { ...state, urlCode: action.urlCode || null };
        case SET_PROMO_ENTERED_CODE:
            return { ...state, enteredCode: action.enteredCode || null };
        case CLEAR_PROMO_ENTERED_CODE:
            return { ...state, enteredCode: null };
        default:
            return state;
    }
}
